import Collection from "backdraft-app/src/collection";

class InvocaCollection extends Collection {
  findOrFetch(id, options = {}) {
    const { success, error, complete } = options;

    let model = this.get(id);

    const modelExists = !!model;

    if (!modelExists) {
      model = this.add({ id });
    }

    if (modelExists) {
      // emulate async response
      if (typeof success === 'function') {
        success(model);
      }

      complete && complete();
    } else {
      model.fetching = true;

      model.fetch({
        success: function(...args) {
          if (typeof success === 'function') {
            success(...args);
          }

          model.fetching = false;
        },

        complete,
        error
      });
    }

    return model;
  }
}

export default InvocaCollection;
